<template>
      <div >
        <v-switch
          inset
          color="#EEBB07"
          v-model="alert.enabled"
          dense
          hide-details
          class="mt-0 mb-3"
          @click="updateAlert(alert)"
        >
        <template v-slot:label>
        {{ $t("message.alert.toggleAlert", { value: "default" }) }}
      </template>
      </v-switch>

        <v-data-table
    :headers="locoHeaders"
    :items="data"
    class="elevation-1 dp"
    hide-default-header
    :loading="loading"
    :loading-text="$t('message.loadingText', { value: 'default' })"
  >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th style="cursor: pointer" v-for="item in headers" :key="item.value">
            {{ item.text }}
          </th>
        </tr>
      </thead>
    </template>
    
    <template v-slot:[`item.mail`]="{ item }">
      <v-switch
        inset
        color="#EEBB07"
        v-model="item.mail"
        dense
        disabled
        hide-details
        class="mt-0"
      ></v-switch>
    </template>
  </v-data-table>
    </div>
    
</template>

<script>
import { mapGetters } from "vuex";
import TeamsService from "@/services/TeamsService.js";

export default {
  data() {
    return {
      alert: {},
      data:[],
      loading:true
    };
  },
  methods: {

    updateAlert(alert) {
      let payload = {
        enabled: alert.enabled
      }
      TeamsService.saveAlert(alert.id, payload)
    },

    loadAlert() {
      TeamsService.getSrAlert(this.getterContact.mail).then(
        response => this.alert = response.data
        ).catch(() =>{
        this.alert = {
                enabled: false,
                mail: undefined
              }}
        );
        this.loading = false
    },
  },

  mounted() {
    this.data = this.getterLocos
    this.loadAlert();
    
    
  },

  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),
    ...mapGetters("customer", {
      getterLocos: "getFilterLoc"
    }),

    locoHeaders() {
      return [
        {
          text: this.$t("message.page.loconumber", { value: "default" }),
          align: "start",
          sortable: true,
          value: "loconum",
        },
        {
          text: this.$t("message.alert.mail", { value: "default" }),
          sortable: true,
          value: "mail",
        }
      ];
    },
  },
};
</script>
<style scoped>
 

  .dp.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  color: #fff;
  font-size: 16px;
}

.theme--light.v-icon {
  color: #fff;
}

.dp.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:hover {
  color: #fff;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}
</style>
